
export class ConcurrencyViolationError extends Error {
    constructor(customMessage?: string) {
        // A derived constructor may only call super() once; the previous implementation called it
        // twice when a custom message was supplied, throwing a ReferenceError instead of the error.
        super(customMessage ?? 'This record has been changed by someone else since you opened it. You will need to refresh the record before making any changes. All unsaved changes will be lost.');
    }
}
